<section #root class="oh-card" aria-label="Overview hub">
  <div class="oh-head oh-head--center">
    <div class="oh-head__center">
      <h2 class="oh-title">Dados dos últimos 7 dias</h2>
     </div>
  </div>

  <div class="oh-body">
    <div class="oh-stage" #stage>
      <svg
        #svgRoot
        class="oh-svg"
        viewBox="0 0 900 360"
        preserveAspectRatio="xMidYMid meet"
        aria-hidden="true"
      >
        <path
          class="oh-arc"
          d="M280 70 C365 35, 510 55, 560 130 C612 205, 560 292, 455 320 C350 348, 285 295, 275 255"
        />

        @for (p of paths; track p.key) {
          <path [attr.d]="p.d" [attr.class]="'oh-line is-idle ' + toneClass(p.tone)"></path>
        }

        @for (p of paths; track p.key) {
          <path
            [attr.d]="p.d"
            [attr.class]="'oh-line is-active ' + toneClass(p.tone) + ' ' + (activeKey === p.key ? 'is-picked' : '')"
          ></path>
        }

        <defs>
          <radialGradient id="diskGlow" cx="35%" cy="30%">
            <stop offset="0%" stop-color="rgba(255,255,255,0.12)" />
            <stop offset="55%" stop-color="rgba(255,255,255,0)" />
          </radialGradient>

          <radialGradient id="diskShade" cx="60%" cy="75%">
            <stop offset="0%" stop-color="rgba(0,0,0,0.38)" />
            <stop offset="60%" stop-color="rgba(0,0,0,0)" />
          </radialGradient>

          <radialGradient id="diskOuterMetal" cx="35%" cy="30%">
            <stop offset="0%" stop-color="var(--disk-metal-1)" />
            <stop offset="42%" stop-color="var(--disk-metal-2)" />
            <stop offset="72%" stop-color="var(--disk-metal-3)" />
            <stop offset="100%" stop-color="var(--disk-metal-4)" />
          </radialGradient>

          <radialGradient id="diskInnerMetal" cx="35%" cy="25%">
            <stop offset="0%" stop-color="var(--disk-inner-1)" />
            <stop offset="100%" stop-color="var(--disk-inner-2)" />
          </radialGradient>

          <radialGradient id="logoPlate" cx="35%" cy="30%">
            <stop offset="0%" stop-color="var(--plate-1)" />
            <stop offset="100%" stop-color="var(--plate-2)" />
          </radialGradient>

          <clipPath id="logoClip">
            <circle cx="0" cy="0" r="54"></circle>
          </clipPath>
        </defs>

        <g>
          <circle class="oh-disk" [attr.cx]="disk.cx" [attr.cy]="disk.cy" [attr.r]="disk.r"></circle>
          <circle class="oh-disk__glow" [attr.cx]="disk.cx" [attr.cy]="disk.cy" [attr.r]="disk.r"></circle>
          <circle class="oh-disk__shade" [attr.cx]="disk.cx" [attr.cy]="disk.cy" [attr.r]="disk.r"></circle>

          <circle class="oh-disk__inner" [attr.cx]="disk.cx" [attr.cy]="disk.cy" [attr.r]="disk.r * 0.52"></circle>
          <circle class="oh-disk__ring" [attr.cx]="disk.cx" [attr.cy]="disk.cy" [attr.r]="disk.r * 0.32"></circle>

          <g class="oh-center" [attr.transform]="'translate(' + disk.cx + ',' + disk.cy + ')'">
            <circle class="oh-logo-plate" cx="0" cy="0" r="56"></circle>

            <g clip-path="url(#logoClip)">
              <image
                class="oh-center-logo"
                href="assets/images/qualitydigital_logo.png"
                x="-56"
                y="-56"
                width="112"
                height="112"
                preserveAspectRatio="xMidYMid meet"
              />
            </g>
          </g>
        </g>
      </svg>

      <div class="oh-actions">
        @for (item of items; track item.key) {
          <button
            type="button"
            [attr.data-key]="item.key"
            [attr.class]="'oh-pill ' + toneClass(item.tone) + ' ' + (activeKey === item.key ? 'is-active' : 'is-idle')"
            (click)="handleClick(item.key)"
            aria-label="{{ item.title }}"
          >
            <span class="oh-pill__badge" aria-hidden="true">
              <i [attr.data-feather]="item.icon" class="oh-pill__icon"></i>
            </span>

            <span class="oh-pill__text">
              <span class="oh-pill__title">{{ item.title }}</span>
            </span>

            <span class="oh-pill__kpi" aria-hidden="true">
              {{ formatCount(item.count) }}
            </span>

            <span class="oh-pill__cap" aria-hidden="true"></span>
          </button>
        }
      </div>
    </div>
  </div>

  <div #transition class="oh-transition" aria-hidden="true"></div>
</section>
